import { useCallback, useContext, useState } from "react";

import ScheduledMessageCreateModal from "@/components/ScheduledMessageComposer/ScheduledMessageCreateModal";
import ModalForm from "@/elements/ModalForm";
import { UxContext } from "@/models/UxStateProvider";

/** Workspace-shell entry for the same scheduled-message composer as the Workflows page. */
export default function ScheduleMessageModal() {
  const { scheduleMessageModalOpen, setScheduleMessageModalOpen } = useContext(UxContext);
  const [hasFormChanges, setFormHasChanges] = useState(false);

  const handleClose = useCallback(() => {
    if (!hasFormChanges) {
      setScheduleMessageModalOpen(false);
    }
  }, [hasFormChanges, setScheduleMessageModalOpen]);

  return (
    <ModalForm
      id="schedule-message"
      maxHeight={750}
      open={scheduleMessageModalOpen}
      onClose={handleClose}
      disableClose={hasFormChanges}
      sx={{ justifyContent: "center", flexGrow: 1 }}
    >
      <ScheduledMessageCreateModal
        askToConfirmClose={false}
        setHasChanges={setFormHasChanges}
        closeModal={() => {
          setScheduleMessageModalOpen(false);
        }}
      />
    </ModalForm>
  );
}
